import { render, staticRenderFns } from "./SecondSidebar.vue?vue&type=template&id=4552d815&scoped=true"
import script from "./SecondSidebar.vue?vue&type=script&lang=js"
export * from "./SecondSidebar.vue?vue&type=script&lang=js"
import style0 from "./SecondSidebar.vue?vue&type=style&index=0&id=4552d815&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552d815",
  null
  
)

export default component.exports